import axios from "../service/axios";
import { getLoggedInUser } from "../utils/authUtils";
import { toast } from "react-toastify";

export const getProducts = async () => {
  try {
    const { data } = await axios.get(`inventory/products`);
    return data;
  } catch (error) {
    console.log('error =>', error)
    const defaultErrorMessage = "Oops Something went wrong";
    toast.error(message || defaultErrorMessage);
  }
}


export const getInventory = async (payload) => {
  const { warehouseCode, searchBy, searchTerm, productName } = payload;
  const searchParams = `search?warehouseCode=${warehouseCode}&searchBy=${searchBy}&searchTerm=${searchTerm}`;
  const promises = [
    axios.get(`inventory/${searchParams}`),
    productName === "docLocation" ? axios.get(`warehouse-layout/bins`) : Promise.resolve(null),
  ]
  try {
    const data = await Promise.all(promises);
    const inventoryList = data[0]?.data?.data;
    const warehouseStorageLocations = data[1]?.data?.data;
    return { inventoryList, warehouseStorageLocations };
  } catch (error) {
    console.log('error', error);
  }
}


export const getCategoriesLookup = async () => {
  try {
    const { data: { data: categories } } = await axios.get(`inventory/categoriesLookup`);
    return categories || [];
  } catch (error) {
    return [];
  }
}

export const getProductsByCategory = async (categoryId) => {
  try {
    const { data: { data: products } } = await axios.get(`inventory/productsByCategory?categoryId=${categoryId}`);
    return products;
  } catch (error) {
    console.log('error', error);
  }
}

export const getLayoutBins = async () => {
  try {
    const { data: { data: bins } } = await axios.get(`warehouse-layout/bins`);
    return bins;
  } catch (error) {
    console.log('error', error);
  }
}


